
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import draggable from "vuedraggable";
import { emptyToLine } from "@common/src/utils/common";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import Duration from "dayjs/plugin/duration";
import DataEmptyGuide from "@/components/scope/data-empty-guide.vue";
dayjs.extend(Duration);
const service = namespace("service");
const app = namespace("app");
const staff = namespace("staff");
const testingItem = namespace("testing-item");
const setting = namespace("setting");
const common_app = namespace("common_app");
@Component({
  components: { draggable, DataEmptyGuide }
})
export default class Template extends Vue {
  @testingItem.Action getTestOrderDetail;
  @service.Action queryDispatchStationList;
  @service.Action queryDispatchOrderList;
  @service.Action queryDispatchStaffList;
  @service.Action updateOrderByDispatch;
  @service.Action updateDispatchByCancel;
  @service.Action getOrderDetail;
  @setting.Getter isOpenDispatch;
  @staff.Action getTechnicianStaffList;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @common_app.State country;
  emptyToLine = emptyToLine;
  dayjs = dayjs;
  showInstruction: boolean = false;
  stationList: any = [];
  orderList: any = [];
  orderListCopy: any = [];
  staffList: any = [];
  filterStationList: any = [];
  showDispatchModal: boolean = false;
  showCancelDispatchModal: boolean = false;
  currentDispatchData: any = {};
  moveId: any = -1;
  dispatchFormRule: any = {
    stationCode: { required: true, message: t("v210831.please-select-station"), trigger: "change" }
  };
  dispatchFormData: any = {
    stationCode: "",
    orderNo: "",
    orderType: "",
    itemArray: "",
    itemArrayService: [],
    itemArrayParts: [],
    technicianCode: ""
  };
  created() {
    if (!localStorage.getItem("isShowInstruction") && this.country === "china") {
      this.showInstruction = true;
      localStorage.setItem("isShowInstruction", "1");
    }
    this.init();
    this.startLoopQuery();
  }
  progressQueueNoArr: any = [];
  // station status enum: 1: 无车辆无技师 2：有车辆无技师 3: 当前工位类型可匹配正在拖动的订单 10：已派工 21：工位类型不匹配
  async init(flag?) {
    this.queryDispatchStaffList().then(data => {
      this.staffList = this.$safeValue(data, "data", []);
    });
    await this.queryDispatchStationList().then(data => {
      let stationList = this.$safeValue(data, "data", []);
      this.stationList = stationList.map((newItem, index) => {
        let item = newItem;
        item.status = item.assignTime ? 10 : 1;
        item.orderData = {};
        item.staffList = [];
        item.timeConsuming = "";
        item.technicianNamesArr = item.technicianNames ? item.technicianNames.split(",") : [];
        item.isCheckOrder = item.orderType === "4";
        if (item.isCheckOrder) {
          item.orderData = { templateName: item.itemArray[0] ? item.itemArray[0].detailName : "" };
        }
        if (
          flag !== "refresh" &&
          !item.assignTime &&
          this.stationList[index] &&
          this.stationList[index].plateCode &&
          !this.stationList[index].assignTime
        ) {
          return this.stationList[index];
        } else {
          return item;
        }
      });
      if (!this.filterStationList.length) {
        this.filterStationList = this.stationList.slice();
      }
      this.startTimeConsumingTimer();
      this.handleSearchOrder();
    });
  }
  refreshProgressOrderNoArr() {
    this.progressQueueNoArr = [];
    this.stationList.forEach(item => {
      if (item.status !== 10 && item.queueNo) {
        this.progressQueueNoArr.push(item.queueNo);
      }
    });
  }
  handleSearchOrder() {
    this.refreshProgressOrderNoArr();
    this.queryDispatchOrderList({
      plateCode: this.plateCodeKeyword
    }).then(data => {
      this.orderList = this.$safeValue(data, "data", []).filter(item => {
        return !this.progressQueueNoArr.includes(item.queueNo);
      });
      this.orderListCopy = this.orderList.slice();
    });
  }
  refreshTimer: any;
  startTimeConsumingTimer() {
    clearInterval(this.refreshTimer);
    this.stationList.forEach(station => {
      if (station.assignTime) {
        let diff = dayjs().diff(dayjs(station.assignTime));
        let diffDuration = dayjs.duration(diff);
        station.timeConsuming = this.getTimeFun(diffDuration);
      }
    });
    this.refreshTimer = setInterval(() => {
      this.stationList.forEach(station => {
        if (station.assignTime) {
          let diff = dayjs().diff(dayjs(station.assignTime));
          let diffDuration = dayjs.duration(diff);
          station.timeConsuming = this.getTimeFun(diffDuration);
        }
      });
    }, 1010);
  }
  handleConfirmDispatch() {
    this.dispatchFormData.itemArray = [
      ...this.dispatchFormData.itemArrayService,
      ...this.dispatchFormData.itemArrayParts
    ];
    if (this.currentDispatchData.isCheckOrder) {
      this.dispatchFormData.itemArray = [];
    }
    this.btnStartLoading();
    this.updateOrderByDispatch(this.dispatchFormData)
      .then(() => {
        this.$message.success(t("v210831.order-dispatched"));
        this.showDispatchModal = false;
        this.init("refresh");
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  getTimeFun(diffDuration) {
    if (diffDuration.$ms < 0) return "";
    let hours = parseInt(diffDuration.as("hours"));
    let minutes = diffDuration.get("minutes");
    let seconds = diffDuration.get("seconds");
    return `${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes}:${
      seconds < 10 ? "0" + seconds : seconds
    }`;
  }

  dragStaffEnd(e) {
    if (this.moveId === -1) return;
    var that = this;
    var endStation = this.stationList.find(function (m) {
      return m.stationCode == that.moveId;
    });
    // 还没选择订单
    if (endStation.status === 1) {
      return false;
    }
    // 检测单只能指派一名技师
    if (endStation.isCheckOrder && endStation.staffList.length > 0) {
      this.$message.error(t("v210831.only-one-technician"));
      return false;
    }
    if (
      endStation.staffList.some(staff => {
        return staff.technicianCode === this.staffList[e.newDraggableIndex].technicianCode;
      })
    ) {
      return this.$message.warning(t("v210831.the-technician-already"));
    }
    endStation.staffList.push(this.staffList[e.newDraggableIndex]);
    this.moveId = -1;
  }
  draggingOrderData: any = {};
  startDragType: string = "";
  canDispatchStationCodeArr = [];
  dragOrderStart(e) {
    this.draggingOrderData = Object.assign({}, this.orderList[e.oldDraggableIndex]);
    this.startDragType = "order";
    this.stationList.forEach(station => {
      if (
        this.orderIsMacthStation(this.orderList[e.oldDraggableIndex].orderType, station.stationType) &&
        station.status === 1
      ) {
        this.canDispatchStationCodeArr.push(station.stationCode);
      }
    });
    console.log(111111);
  }
  dragStaffStart() {
    this.moveId = -1;
    this.startDragType = "staff";
  }
  dragOrderEnd(e) {
    this.canDispatchStationCodeArr = [];
    console.log(e);
    if (this.moveId === -1) return;
    var that = this;
    let endStation = this.stationList.find(function (m) {
      return m.stationCode == that.moveId;
    });
    endStation.plateCode = this.orderList[e.newDraggableIndex].plateCode;
    endStation.status = 2;
    if (endStation.queueData) {
      this.orderList.push(endStation.queueData);
    }
    endStation.queueData = this.orderList[e.newDraggableIndex];
    if (this.orderList[e.newDraggableIndex].orderType !== "4") {
      this.getOrderInfo(this.orderList[e.newDraggableIndex].orderNo, endStation);
      endStation.isCheckOrder = false;
    } else {
      this.getCheckOrderInfo(this.orderList[e.newDraggableIndex].orderNo, endStation);
      if (endStation.staffList && endStation.staffList.length > 0) {
        endStation.staffList = endStation.staffList.slice(0, 1);
      }
      endStation.isCheckOrder = true;
    }
    endStation.queueNo = this.orderList[e.newDraggableIndex].queueNo;
    this.orderList.splice(e.newDraggableIndex, 1);
    this.moveId = -1;
  }
  getTypeMatch(station, order) {
    if (station.stationType === "5" && (order.orderType === "1" || order.orderType === "4")) {
      return true;
    }
    if (station.stationType === "10" && order.orderType === "2") {
      return true;
    }
    return false;
  }
  groupIndex: number = 1;
  technicianMap: any = {};
  getOrderInfo(orderNo, station, type?) {
    return this.getOrderDetail({
      orderNo: orderNo
    }).then(data => {
      station.orderData = data.data;
      station.customerVehicleBrandLogo = this.$safeValue(data, "data.customerVehicleBrandLogo", "");
      const serviceCodeMap = {}; // 存放映射关系
      data.data.partsDetail.forEach((parts, index) => {
        if (parts.serviceCode) {
          if (serviceCodeMap[parts.serviceCode]) {
            serviceCodeMap[parts.serviceCode].push(index);
          } else {
            serviceCodeMap[parts.serviceCode] = [index];
          }
        }
      });
      data.data.serviceDetail.forEach(serviceItem => {
        if (serviceCodeMap[serviceItem.serviceCode]) {
          serviceItem.isGroup = true;
          serviceItem.groupServiceIndex = this.groupIndex;
          serviceCodeMap[serviceItem.serviceCode].forEach(i => {
            data.data.partsDetail[i].isGroup = true;
            data.data.partsDetail[i].groupServiceIndex = this.groupIndex;
          });
          this.groupIndex++;
        }
      });
      if (type === "reset") {
        this.technicianMap = {};
        station.itemArray.forEach(item => {
          this.technicianMap[item.detailNo] = item.technicianArray;
        });
      } else {
        this.technicianMap = {};
      }
      station.itemArray = [...data.data.serviceDetail, ...data.data.partsDetail].map(item => {
        item.detailTypeDesc = item.partsCode ? t("parts.text") : t("finance.service-items");
        item.detailNo = item.orderDetailNo;
        item.detailName = item.partsName || item.serviceName;
        return item;
      });
    });
  }
  getCheckOrderInfo(orderNo, station) {
    return this.getTestOrderDetail({
      checkOrderNo: orderNo
    }).then(data => {
      station.orderData = data.data;
      station.customerVehicleBrandLogo = this.$safeValue(data, "data.customerVehicleBrandLogo", "");
    });
  }
  handleTechnicianChange(row) {
    if (row.isCheckOrder) {
      this.dispatchFormData.technicianCode = row.technicianArray;
    }
  }
  //move回调方法
  wait = 200;
  timer: any = 0;
  timeStamp = 0;
  mismatchId: number = -1;
  onMove(e) {
    if (Date.now() - this.timeStamp < this.wait) {
      clearTimeout(this.timer);
    }
    // 防抖
    this.timer = setTimeout(() => {
      this.moveId = -1;
      this.mismatchId = -1;
    }, this.wait);
    this.timeStamp = Date.now();
    if (e.relatedContext.element.stationCode && e.relatedContext.element.status !== 10) {
      this.moveId = e.relatedContext.element.stationCode;
      this.mismatchId = -1;
      if (this.startDragType === "order" && !this.getTypeMatch(e.relatedContext.element, this.draggingOrderData)) {
        this.mismatchId = e.relatedContext.element.stationCode;
        this.moveId = -1;
      }
    } else {
      this.moveId = -1;
      this.mismatchId = 1;
    }
    // 不停靠
    return false;
  }
  destoryed() {
    clearInterval(this.timer);
  }
  handleRemoveOrder(station) {
    station.staffList = [];
    station.status = 1;
    station.orderData = {};
    station.plateCode = "";
    station.queueNo = "";
    this.orderList.push(station.queueData);
    station.queueData = undefined;
  }
  handleRemoveTechnician(station, technicianIndex) {
    station.staffList.splice(technicianIndex, 1);
  }
  async handleStationCommand(command, stationData) {
    this.currentDispatchData = stationData;
    if (command === "cancel") {
      this.showCancelDispatchModal = true;
    } else if (command === "reset") {
      if (stationData.orderType !== "4") {
        await this.getOrderInfo(stationData.orderNo, stationData, "reset");
      } else {
        await this.getCheckOrderInfo(stationData.orderNo, stationData);
      }
      this.handleShowDispatchModal(stationData, "reset");
    }
  }
  queryTimer: any = 0;
  startLoopQuery() {
    this.queryTimer = setInterval(() => {
      this.init();
    }, 60000);
  }
  handleRefresh() {
    this.init();
  }
  handleLinkOrderDetail(station) {
    if (station.orderType === "4") {
      let { href } = this.$router.resolve({
        path: `/test/view/${station.orderNo}`
      });
      window.open(href, "_blank");
    } else {
      let { href } = this.$router.resolve({
        path: `/service/view/${station.orderNo}`
      });
      window.open(href, "_blank");
    }
  }
  plateCodeKeyword: string = "";
  handleCancelDispatch() {
    this.btnStartLoading();
    this.updateDispatchByCancel({
      stationCode: this.currentDispatchData.stationCode
    })
      .then(() => {
        this.$message.success(t("v210831.dispatch-cancelled"));
        this.showCancelDispatchModal = false;
        this.init();
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }

  orderIsMacthStation(orderType, stationType) {
    if (orderType === "2" && stationType === "10") {
      return true;
    }
    if (orderType !== "2" && stationType === "5") {
      return true;
    }
    return false;
  }
  isReset: boolean = false;
  handleShowDispatchModal(station, type?) {
    if (type === "reset") {
      this.isReset = true;
    } else {
      this.isReset = false;
    }
    if (station.staffList.length < 1 && type !== "reset") {
      return this.$message.error(t("v210831.please-specify-technician"));
    }
    this.currentDispatchData = station;
    this.dispatchFormData.stationCode = station.stationCode;
    this.dispatchFormData.orderNo = station.orderData.orderNo || station.orderData.checkOrderNo;
    this.dispatchFormData.orderType = station.orderData.orderType || "4"; // 服务单有orderTYpe字段，没有就设置为检测单"4"
    if (type === "reset") {
      this.dispatchFormData.technicianCode = station.orderData.technicianCode;
    } else {
      this.dispatchFormData.technicianCode = station.staffList[0].technicianCode;
    }
    if (station.isCheckOrder) {
      this.dispatchFormData.itemArrayParts = [];
      if (type === "reset") {
        this.dispatchFormData.itemArrayService = [
          {
            detailName: station.orderData.templateName,
            technicianArray: station.orderData.technicianCode,
            isCheckOrder: true
          }
        ];
      } else {
        this.dispatchFormData.itemArrayService = [
          {
            detailName: station.orderData.templateName,
            technicianArray: station.staffList[0].technicianCode,
            isCheckOrder: true
          }
        ];
      }
    } else {
      this.dispatchFormData.itemArrayService = this.$safeValue(station.orderData, "serviceDetail", []).map(item => {
        item.detailNo = item.orderDetailNo;
        item.detailName = item.serviceName || item.partsName;
        item.technicianArray = this.technicianMap[item.detailNo] || station.staffList;
        item.detailType = "10";
        return item;
      });
      this.dispatchFormData.itemArrayParts = this.$safeValue(station.orderData, "partsDetail", []).map(item => {
        item.detailNo = item.orderDetailNo;
        item.detailName = item.serviceName || item.partsName;
        item.technicianArray = item.isGroup ? [] : this.technicianMap[item.detailNo] || station.staffList;
        item.detailType = "5";
        return item;
      });
    }
    this.filterStationList = this.stationList.slice();
    this.filterStationList = this.filterStationList.filter(station => {
      return (
        (station.status !== 10 || station.stationCode === this.dispatchFormData.stationCode) &&
        this.orderIsMacthStation(this.dispatchFormData.orderType, station.stationType)
      );
    });
    this.showDispatchModal = true;
  }
}
